import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CrudTableViewConfig, CrudViewColumnType } from '../../utils/list-grid';
import { ButtonComponentConfig } from '../../utils/button';
import { AlertConfig } from '../../utils/alert';
import { isEqual } from 'lodash';
import { EditFormComponentConfig } from '../../utils/form-card';

@Component({
  selector: 'rappider-file-explorer-with-selected-list',
  templateUrl: './file-explorer-with-selected-list.component.html',
  styleUrls: ['./file-explorer-with-selected-list.component.scss'],
})
export class RappiderFileExplorerWithSelectedListComponent implements OnChanges {

  @Input() activeEntityData = [];
  @Input() listGridConfig: CrudTableViewConfig;
  @Input() editFormConfig: EditFormComponentConfig;
  @Input() selectedItem: any;
  @Input() loading: boolean;
  @Input() submitButtonLoading = false;
  @Input() buttonConfig: ButtonComponentConfig;
  @Input() selectedButtonConfig: ButtonComponentConfig;
  @Input() alertConfig: AlertConfig;
  @Input() selectedFileListInfoAlertConfig: AlertConfig;
  // It stores the state of the nested folders.
  @Input() folderOrder;
  @Input() isFileListStatic = true;
  @Input() selectedListEditFormVisible = true;

  @Input() selectedListGridConfig: CrudTableViewConfig = {
    searchable: true,
    sortable: true,
    pageSize: 10,
    selectable: true,
    enableMultipleSelection: true,
    columns:
      [
        {
          title: 'File Name',
          type: CrudViewColumnType.Text,
          fieldName: 'name',
          visible: true,
          prefixIconVisible: true,
        }
      ],
    orderable: false,
    listActions: [],
    itemActions: []
  };

  @Input() selectedData;

  @Output() searchTextChange = new EventEmitter();
  @Output() rowActionClick = new EventEmitter();
  @Output() overflowlistItemClick = new EventEmitter();
  @Output() buttonConfirm = new EventEmitter();
  @Output() buttonClick = new EventEmitter();
  @Output() selectList = new EventEmitter();
  @Output() selectedList = new EventEmitter();
  @Output() formValueChange = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.activeEntityData || changes.selectedData) && !this.isFileListStatic) {
      if (!isEqual(this.activeEntityData, this.activeEntityData?.map(item => ({
        ...item,
        selected: this.selectedData?.map(data => data.id)?.includes(item.id)
      })))) {
        this.activeEntityData.forEach((obj1, i) =>
          Object.keys(this.activeEntityData?.map(item => ({
          ...item,
          selected: this.selectedData?.map(data => data.id)?.includes(item.id)
        }))[i]).forEach(key => {
            if (obj1[key] !== this.activeEntityData?.map(item => ({
          ...item,
          selected: this.selectedData?.map(data => data.id)?.includes(item.id)
        }))[i][key]) obj1[key] = this.activeEntityData?.map(item => ({
          ...item,
          selected: this.selectedData?.map(data => data.id)?.includes(item.id)
        }))[i][key];
          })
        );
      }
    }
  }

  onSearchTextChange(text) {
    this.searchTextChange.emit(text);
  }

  onRowActionClick(row) {
    this.rowActionClick.emit(row);
  }

  onOverflowlistItemClick(item) {
    this.overflowlistItemClick.emit(item);
  }

  onConfirm() {
    this.buttonConfirm.emit();
  }

  onButtonClick() {
    this.buttonClick.emit(this.selectedData);
  }

  onSelectionChange(selectedData) {
    if (this.isFileListStatic) {
      this.selectedData = selectedData;
      this.selectList.emit(selectedData);
    } else {
      const selectList = this.activeEntityData.map(item => ({
        ...item,
        selected: selectedData.some(s => s.id === item.id)
      }));
      this.selectList.emit(selectList);
    }
  }

  onSelectedListSelectionChange(selectedList) {
    this.selectedList.emit(selectedList);
  }

  onFormValueChange(formValue){
    this.formValueChange.emit(formValue);
  }

}
